import { render, staticRenderFns } from "./MasterDetail.vue?vue&type=template&id=a3ad60fa"
import script from "./MasterDetail.vue?vue&type=script&lang=js"
export * from "./MasterDetail.vue?vue&type=script&lang=js"
import style0 from "./MasterDetail.vue?vue&type=style&index=0&id=a3ad60fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports